export const SENDING_STATE = [
    { value: 'not_sent', i18n: 'notSent' },
    { value: 'sent', i18n: 'sent' },
    { value: 'send_back', i18n: 'sendBack' },
    { value: 'sending', i18n: 'sending' }
]

export const INVOICE_HEADER_TYPE = [
    { value: 'receipt', i18n: 'headerTypeReceipt' },
    { value: 'invoice', i18n: 'headerTypeInvoice' },
    { value: 'receipt_only', i18n: 'headerTypeReceiptOnly' }
]
